var paragraph_default = {
  "fontElementMap": "ZuH2e",
  "elementSpacing": "qUjZI",
  "text": "-SRE- qUjZI",
  "child": "L6Pq-"
};
export {
  paragraph_default as default
};
//# sourceMappingURL=paragraph-scss.js.map
